import { Row, Col } from "../../bootstrap.js";
import "./interview.css";
import interviews from "./interviews.json";
import { useEffect, useState } from "react";

export function Interview() {
  const [activeVideo, setActiveVideo] = useState(null);

  const closeModal = () => setActiveVideo(null);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        closeModal();
      }
    };

    if (activeVideo) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "auto";
    };
  }, [activeVideo]);

  return (
    <>
      <Row className="featuredPub gy-3 interviewHeaderRow" id="interviews">
        <h2 className="redHeaderPub">VOICES OF THE COMBINE LAB</h2>
        <p className="text-center interviewIntro">
          Hear directly from our students about their research, experiences, and impact.
        </p>
      </Row>

      <Row className="gy-4 justify-content-center interviewCardsRow">
        {interviews.map((item, index) => (
          <Col xs={12} md={6} key={index} className="d-flex justify-content-center">
            <div className="interviewCardNew">
              <div
                className="videoSection"
                onClick={() => setActiveVideo(item.embedUrl)}
                role="button"
                tabIndex={0}
                aria-label={`Play interview for ${item.name}`}
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    setActiveVideo(item.embedUrl);
                  }
                }}
              >
                <img
                  src={item.thumbnail}
                  alt={`${item.name} interview thumbnail`}
                  className="videoThumbnail"
                />
                <div className="thumbnailOverlay"></div>
                <div className="playButton">▶</div>
              </div>

              <div className="textSection">
                <h3>{item.name}</h3>
                <p className="role">{item.role}</p>
                <p className="desc">{item.description}</p>
              </div>
            </div>
          </Col>
        ))}
      </Row>

      {activeVideo && (
        <div className="videoModal" onClick={closeModal}>
          <div
            className="videoModalContent"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="closeButton"
              onClick={closeModal}
              aria-label="Close video modal"
              type="button"
            >
              ×
            </button>

            <iframe
              src={activeVideo}
              title="Interview video"
              allowFullScreen
            />
          </div>
        </div>
      )}
    </>
  );
}